<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="chapter">
<div class="bodymatter" epub:type="bodymatter">
<section epub:type="division">
<h1 class="part" id="p01"><a id="pagexiv"></a><a id="page1"></a><i>Part One</i></h1>
<h1 class="part_chap">PLANT CARE BASICS</h1>
<div class="dis_img" id="page_xiv"><img alt="" src="Images/xiv-1.jpg"/></div>
</section>
</div>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781454932918_epub_p01_r1.vue?1aa9dbb5